const MONGO_OBJECT_ID_REGEX = /^[0-9a-f]{24}$/i;

export const isValidOrderId = (value: unknown): value is string =>
  typeof value === 'string' && MONGO_OBJECT_ID_REGEX.test(value);
